import React from 'react';
import styled from 'styled-components';
import { Captions, ShortBody } from 'components/Typography';
import { Grid } from '@material-ui/core';
import { Accordion, AccordionDetails } from '@material-ui/core';

export const StyledValidAccordion = styled(({ color, ...otherProps }) => (
  <Accordion {...otherProps} />
))`
  border-radius: 8px !important;
  border-bottom-right-radius: 8px !important;
`;
export const StyledCaption = styled(Captions)`
  && {
    color: #838ea4;
    font-size: 13px !important;
    line-height: 18px !important;
    margin: 0;
  }
`;
export const StyledShortBody = styled(({ reverse, ...otherProps }) => (
  <ShortBody {...otherProps} />
))`
  && {
    font-weight: 500;
    margin-bottom: 0;
    font-size: 17px !important;
    line-height: 20px !important;
    text-align: ${(props) => (props.reverse ? 'right' : 'left')}!important;
  }
`;
export const StyledLink = styled.a`
  && {
    text-decoration: none;
  }
`;

export const AlignedGrid = styled(Grid)`
  align-self: center;
`;

export const SizedGrid = styled(Grid)`
  min-height: 200px;
`;
export const formStyle = {
  infoIcon: {
    cursor: 'pointer',
    height: '20px',
    width: '20px',
    color: '#C2D1D9',
    '&:hover': {
      borderRadius: '50%',
    },
  },
};
export const StyledGridLeft = styled(Grid)`
  margin-left: 3px;
  margin-top: 1px;
`;
export const StyledAccordionDetails = styled(AccordionDetails)`
  && {
    padding: 24px 16px;
    border-left: none;
    border-top: 1px solid #e7e7e7;
  }
`;
